export enum eSettingsNames
{
  language="AppLanguageId",
  theme="AppThemeName"
}
export enum eThemesNames
{
  dark="dark_Default",
  light="light_Default"
}
export enum eDefaultLanguageApp
{
  laguageDefault = "es-mx"
}
export enum eTipoNotificacion
{
  Normal = 0,
  Warning = 10,
  Error = 20
}
export enum eRolAppUsuario
{
  None = 0,
  Empleado = 1,
  Cliente = 2
}
export enum eAppPaths 
{  
  login = 'login',
  homeEmpleado='inicio',  
  homeCliente = 'socio',
}
export enum ePathshomeEmpleado 
{ 
  socios = 'listSocios',
  socioContrato = 'socioContrato', 
  socioInvoices='socioRecibos',
  socioInvoice='socioRecibo',
  socioDetail = 'socioDetail',
  contracts = 'listContratos',
  contratoDetail='contratoDetail',
  contratoRecibosList='contratoRecibosList',
  contratoReciboDetail = 'contratoReciboDetail',
  contratoAgreementsList='contratoConveniosList',
  contratoAgreementDetail='contratoAgreementDetail',
  socioDocumentos='socioDocumentos',
  socioDocumento='socioDocumento',
}
export enum eTiposClienteRest 
{ 
  WebERP = 1
}
export enum eStatusCode 
{
  Ok = 0,
  Error = 1,
  Fatal = 2 
}
export enum eTipoFile
{
    Image = 1,
    Pdf = 2,
    Other = 3
}
export enum eProductType 
{
   Cargo = 1,
   Abono = 2
}
export enum eDiscounType 
{ 
  None = 0,
  Amount = 1, 
  Percent=2
}
export enum eInvoiceStatus 
{ 
  Pagada = 10, 
  Vigente = 20, 
  NoPagada = 30
}
/**1	RM
   2	RC
   3	RA 
   4  RAM*/
export enum eInvoiceClass 
{ 
  RM = 1,
  RC = 2,
  RA = 3,
  RAM = 4
}
export enum eInvoiceRel 
{ 
  Contract = 1,
  Convenio = 2,  
  Customer = 3
}
export enum eTypeEdoCta 
{ 
  Contract = 1,
  Customer = 2
}